import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'raceAnnex'
})
export class RaceAnnexPipe implements PipeTransform {
  transform(value: string): any {
    value.includes('Altersgewichtsrennen') && (value = value.replace('Altersgewichtsrennen', 'Conditional Race'));
    value.includes('Verkaufsrennen') && (value = value.replace('Verkaufsrennen', 'Claiming Race'));
    value.includes('Amateurrennen') && (value = value.replace('Amateurrennen', 'Amateur Race'));
    return value;
  }
}
